/**
 * Loading Modal Component
 * Reusable full-screen loading overlay with spinner and message
 */

import React from 'react';

interface LoadingModalProps {
  message?: string;
  subMessage?: string;
}

export const LoadingModal: React.FC<LoadingModalProps> = ({
  message = 'Loading...',
  subMessage,
}) => {
  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content">
        <div className="loading-spinner"></div>
        <div className="loading-message">{message}</div>
        {subMessage && <div className="loading-submessage">{subMessage}</div>}
      </div>
    </div>
  );
};
